import React from "react";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import swal from 'sweetalert';
import {Button, Modal, Form, Spinner} from "react-bootstrap";
import {save, update} from "../services/doctorsService";
import {getInputClasses} from "../../_utils/getInputclasses";

import AlertError from "../../components/AlertError"

const FormDoctor = (props) => {
    const validationSchema = Yup.object().shape({
        doctorName: Yup.string()
            .required("El campo es requerido"),
        doctorFatherLastname: Yup.string()
            .required("El campo es requerido"),
        doctorMotherLastname: Yup.string()
            .required("El campo es requerido"),
    });

    const onSubmit = (values, { setStatus, setSubmitting }) => {
        values.fullName = `${values.doctorFatherLastname} ${values.doctorMotherLastname} ${values.doctorName}`;
        setTimeout(() => {
            if (props.shouldUpdate) {
                update(values, props.doctor.id).then(response => {
                    props.getDoctors();
                    props.handleClose();
                    swal("Guardado Exitoso", "Se ha guardado", "success");
                }).catch( () => {
                    setSubmitting(false);
                    setStatus("Ocurrio algun error al actualizar");
                });
            } else {
                values.isActive = 1;
                save(values).then(response => {
                    props.getDoctors();
                    props.handleClose();
                    swal("Guardado Exitoso", "Se ha guardado", "success");
                }).catch( () => {
                    setSubmitting(false);
                    setStatus("Ocurrio algun error al guardar");
                });
            }
        }, 1000);
    };

    return (
        <>
            <Modal show={props.showModal} onHide={props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.shouldUpdate ? "Editar" : "Agregar"} doctor</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik initialValues={{...props.doctor}} onSubmit={onSubmit} validationSchema={validationSchema}>
                        {({values, errors, touched, handleChange, handleSubmit, status, isSubmitting}) => (
                            <>
                                <AlertError status={status} />
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="doctorName">
                                        <Form.Label>Nombre</Form.Label>
                                        <Form.Control type="text"
                                                    value={values.doctorName}
                                                    onChange={handleChange}
                                                    name="doctorName"
                                                    placeholder="Escribe el nombre"
                                                    className={`${getInputClasses(touched, errors, "doctorName")}`} />
                                            <ErrorMessage name="doctorName">
                                                { msg => (
                                                    <Form.Control.Feedback type="invalid">
                                                        {msg}
                                                    </Form.Control.Feedback>
                                                )}
                                            </ErrorMessage>
                                    </Form.Group>

                                    <Form.Group controlId="doctorFatherLastname">
                                        <Form.Label>Apellido paterno</Form.Label>
                                        <Form.Control type="text"
                                                    value={values.doctorFatherLastname}
                                                    onChange={handleChange}
                                                    name="doctorFatherLastname"
                                                    placeholder="Escribe el nombre"
                                                    className={`${getInputClasses(touched, errors, "doctorFatherLastname")}`} />
                                            <ErrorMessage name="doctorFatherLastname">
                                                { msg => (
                                                    <Form.Control.Feedback type="invalid">
                                                        {msg}
                                                    </Form.Control.Feedback>
                                                )}
                                            </ErrorMessage>
                                    </Form.Group>

                                    <Form.Group controlId="doctorMotherLastname">
                                        <Form.Label>Apellido materno</Form.Label>
                                        <Form.Control type="text"
                                                    value={values.doctorMotherLastname}
                                                    onChange={handleChange}
                                                    name="doctorMotherLastname"
                                                    placeholder="Escribe el nombre"
                                                    className={`${getInputClasses(touched, errors, "doctorMotherLastname")}`} />
                                            <ErrorMessage name="doctorMotherLastname">
                                                { msg => (
                                                    <Form.Control.Feedback type="invalid">
                                                        {msg}
                                                    </Form.Control.Feedback>
                                                )}
                                            </ErrorMessage>
                                    </Form.Group>

                                    <Form.Group controlId="category">
                                        <Form.Label>Categoria</Form.Label>
                                        <Form.Control as="select"
                                                    value={values.category}
                                                    onChange={handleChange}
                                                    name="category"
                                                    className={`${getInputClasses(touched, errors, "category")}`}>
                                            <option value="">Selecciona una opcion...</option>
                                            <option value="VIP">VIP</option>
                                        </Form.Control>
                                        <ErrorMessage name="category">
                                            { msg => (
                                                <Form.Control.Feedback type="invalid">
                                                    {msg}
                                                </Form.Control.Feedback>
                                            )}
                                        </ErrorMessage>
                                    </Form.Group>

                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                        {isSubmitting && <Spinner as="span" animation="border" variant="dark" size="sm" />}
                                        Guardar
                                    </Button>
                                </Form>
                            </>
                        )}
                    </Formik>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default FormDoctor;
